import Grid from "@mui/material/Grid2";
import {
  Box,
  Link,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";

import {
  AmeriHealthList,
  AmeriItalicText,
  FlexRow,
  InputHeader,
  ListItemStyle,
  memberContinue,
  MemberNotFoundList,
  StyleGridRow,
  uploadHyperLink,
} from "../../CreatePriorAuth/style/style";
import { InformationText } from "../../../app/common/TextLabel";
import fontWeight from "../../../styles/mui/fontWeight";
import colors from "../../../styles/colors/colors";
import { TextConstants } from "../../../constants/Patient";
import { getValue, isEligible } from "../../../utils";
import { tangoCareUploadUrl } from "../../../constants/Config";
import { Numbers } from "../../../constants/Referral";

export interface Props {
  warningType: number;
  openEligibilityCheck?: boolean;
  eligibilityData?: any;
}
const PatientHealthPlanVerbiage = ({
  warningType,
  openEligibilityCheck,
  eligibilityData,
}: Props) => {
  return (
    <>
      {warningType === 1 && (
        <Grid container spacing={2} mt={1} sx={FlexRow}>
          <Grid mr={2} sx={StyleGridRow}>
            {InformationText(
              "ALERT: ",
              fontWeight[3],
              {},
              colors.red[90],
              false
            )}
          </Grid>
          <Grid size={{ xs: 11 }}>
            {InformationText(
              TextConstants.HCSC_CHECK,
              fontWeight[3],
              {},
              colors.portalColor[19],
              false
            )}
          </Grid>
        </Grid>
      )}
      {warningType === 2 && (
        <Grid container spacing={2} mt={1} sx={FlexRow}>
          <Grid mr={2} sx={StyleGridRow}>
            {InformationText(
              "ALERT: ",
              fontWeight[3],
              {},
              colors.red[90],
              false
            )}
          </Grid>
          <Grid size={{ xs: 11 }}>
            {InformationText(
              TextConstants.AMERIHEALTH_CARITAS_CHECK,
              fontWeight[3],
              {},
              colors.portalColor[19],
              false
            )}
            <Grid size={{ xs: 12 }} sx={StyleGridRow}>
              <List sx={AmeriHealthList}>
                {[
                  {
                    key: "not-found",
                    text: (
                      <>
                        If the member’s eligibility{" "}
                        <Typography pl={1} pr={0.7} component="span" sx={AmeriItalicText}>
                          is not found
                        </Typography>{" "}
                        by Tango’s eligibility team, you will be notified via
                        the email and phone number provided in your request.
                      </>
                    ),
                  },
                  {
                    key: "verified",
                    text: (
                      <>
                        {TextConstants.IF_THE_MEMBERS_ELIGIBILITY}{" "}
                        <Typography pl={1} pr={0.7}  component="span" sx={AmeriItalicText}>
                          is verified
                        </Typography>
                        , an authorization will be issued, and the member will
                        appear in the Auth Tracker on your portal home screen.
                      </>
                    ),
                  },
                ].map(({ key, text }) => (
                  <ListItem key={key} sx={{ display: "list-item", pt: 0 }}>
                    <ListItemText
                      primary={<Typography variant="h5">{text}</Typography>}
                    />
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Grid>
        </Grid>
      )}
      {[Numbers.THREE, Numbers.Four, Numbers.Five].includes(warningType) && (
        <Grid container spacing={2} mt={1} sx={FlexRow}>
          <Grid mr={2} sx={StyleGridRow}>
            {InformationText(
              "ALERT: ",
              fontWeight[3],
              {},
              colors.red[90],
              false
            )}
          </Grid>
          <Grid size={{ xs: 11 }}>
            {InformationText(
              TextConstants.BLUE_CROSS_BCBS_TN_MICHIGAN_CHECK,
              fontWeight[3],
              {},
              colors.portalColor[19],
              false
            )}
          </Grid>
        </Grid>
      )}
      {openEligibilityCheck && isEligible(getValue(eligibilityData, "response")) === false && (
        <>
          <Grid size={{ xs: 12 }} mt={3} pr={1} pb={1} sx={InputHeader}>
            {InformationText(
              TextConstants.MEMBER_NOT_FOUND,
              fontWeight[4],
              {},
              colors.black[1]
            )}
          </Grid>
          <Grid size={{ xs: 12 }} sx={StyleGridRow}>
            <List sx={MemberNotFoundList}>
              <ListItem sx={ListItemStyle}>
                <ListItemText
                  primary={InformationText(
                    TextConstants.MEMBER_INFO1,
                    fontWeight[4],
                    {},
                    colors.black[1]
                  )}
                />
              </ListItem>
              <ListItem sx={ListItemStyle}>
                <ListItemText
                  primary={InformationText(
                    TextConstants.MEMBER_INFO2,
                    fontWeight[4],
                    {},
                    colors.black[1]
                  )}
                />
              </ListItem>
              <ListItem sx={ListItemStyle}>
                <ListItemText
                  primary={InformationText(
                    TextConstants.MEMBER_INFO3,
                    fontWeight[4],
                    {},
                    colors.black[1]
                  )}
                />
              </ListItem>
            </List>
          </Grid>
          <Grid size={{ xs: 12 }} mt={1.5} pr={1} sx={InputHeader}>
            {InformationText(
              TextConstants.MEMBER_CONFIRM,
              fontWeight[4],
              {},
              colors.black[1]
            )}
          </Grid>
          <Grid size={{ xs: 12 }} pr={1} sx={InputHeader}>
            <Typography
              fontWeight={fontWeight[5]}
              color={colors.black[1]}
              variant="body2"
              sx={memberContinue}
            >
              <Box component="span" sx={{ display: "inline" }}>
                {InformationText(
                  TextConstants.MEMBER_CONTINUE,
                  fontWeight[4],
                  {},
                  colors.black[1]
                )}
              </Box>
              <Link
                fontWeight={fontWeight[4]}
                href={tangoCareUploadUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={uploadHyperLink}
              >
                &nbsp;{tangoCareUploadUrl}
              </Link>
              <Box component="span" sx={{ display: "inline" }}>
                <Typography
                  variant="h5"
                  fontWeight={fontWeight[4]}
                  color={colors.black[1]}
                >
                  {" "}
                  .{" "}
                </Typography>
              </Box>
            </Typography>
          </Grid>
        </>
      )}
    </>
  );
};

export default PatientHealthPlanVerbiage;
